module.exports = __webpack_public_path__ + "static/img/JA.2c4cdf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/banners/h5/JA.png
// module id = Tptu
// module chunks = 1